import { create as d } from "zustand";
import { devtools as n } from "zustand/middleware";
import t from "immer";
const m = d()(
  n(
    (r) => ({
      actions: {
        openSidePanel: (o) => {
          r((e) => ({
            ...e,
            ...o
          }));
        },
        setMapId: (o) => {
          r(
            t((e) => {
              e.mapId = o;
            })
          );
        }
      }
    }),
    {
      enabled: !!(window && window.__REDUX_DEVTOOLS_EXTENSION__)
    }
  )
);
export {
  m as useSidePanelStore
};
//# sourceMappingURL=index.es179.js.map
